import env from "../../../root/env.js";
import { loggingContexts } from "../../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../../root/modules/logs/log.js";
import { pruneLogs } from "../../../root/modules/logs/prune-logs.js";
import { checkInstallerVersion } from "../../functions/check-installer-version.js";
import { checkVersion } from "../../functions/check-version.js";
import { useMainStore } from "../../store/mainStore.js";
import { reportActivity } from "../report-activity/report-activity.js";
import { removeStaleSilencedCases } from "../silence-cases/remove-stale-silenced-cases.js";

const mainLoopLog = log(loggingContexts.mainLoop);

let mainLoopID;

export const mainLoop = async ({ counter = 0, timeout }) => {
  try {
    await Promise.all([
      checkInstallerVersion(),
      checkVersion(),
      removeStaleSilencedCases({
        silencedCaseTimeToStale: env.VITE_SILENCED_CASE_TIME_TO_STALE,
        useMainStore,
      }),
      reportActivity(),
    ]);

    // run once a day ᐯ
    const timeoutInSeconds = timeout / 1000;
    const secondsInADay = 24 * 60 * 60;
    const ticksInADay = secondsInADay / timeoutInSeconds;

    if (counter % ticksInADay === 0) {
      pruneLogs()
        .then((pruneLogsResult) => {
          mainLoopLog.info("prune logs result", pruneLogsResult);
        })
        .catch((error) => {
          mainLoopLog.error("prune logs failed", error.message);
        });
    }
    // run once a day ᐱ
  } catch (error) {
    mainLoopLog.error("something went wrong", { counter, timeout });
    mainLoopLog.error(error.message);
  }

  if (mainLoopID) {
    clearTimeout(mainLoopID);
  }

  mainLoopID = setTimeout(
    () => mainLoop({ counter: counter + 1, timeout }),
    timeout
  );

  return mainLoopID;
};
